import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { Container, Card } from "react-bootstrap";
import MicrosoftLoginButton from "../Common/Components/MicrosoftLoginButton";

// Main Login Component
const MicrosoftLoginPage = () => {
  // const isAuthenticated = useIsAuthenticated();

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <Card style={{ width: "400px" }} className="p-4 d-flex justify-content-center align-items-center ">
        <Card.Body>
          <h3 className="text-center mb-4">Login</h3>
          <MicrosoftLoginButton />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default MicrosoftLoginPage;
